import PhotoSwipe from 'photoswipe';
import PhotoSwipeDefaultLayout from 'photoswipe/dist/photoswipe-ui-default';

import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

(() => {
    const pswp = document.querySelector('.pswp');
    const videoButton = document.querySelector('[data-video-button]');
    const iframeButton = document.querySelector('[data-iframe-button]');

    if (pswp && videoButton) {
        videoButton.addEventListener('click', () => {
            const items = [
                {
                    html: `
                        <div class="pswp-video">
                            <div class="video-wrapper">
                                <iframe src="${videoButton.dataset.url}" />
                            </div>
                        </div>
                    `,
                },
            ];

            const photoSwipe = new PhotoSwipe(
                pswp,
                PhotoSwipeDefaultLayout,
                items,
            );

            photoSwipe.init();
        });
    }

    if (pswp && iframeButton) {
        iframeButton.addEventListener('click', () => {
            const items = [
                {
                    html: `
                        <div class="pswp-iframe">
                            <iframe src="${iframeButton.dataset.url}" />                           
                        </div>
                    `,
                },
            ];

            const photoSwipe = new PhotoSwipe(
                pswp,
                PhotoSwipeDefaultLayout,
                items,
            );

            photoSwipe.init();
        });
    }
})();
